<nav class=" navbar navbar-expand-lg navbar-absolute navbar-transparent">
  <div class=" container-fluid">
    <div class=" navbar-wrapper">
      <div class=" navbar-toggle d-inline">
        <button class=" navbar-toggler" type="button" (click)="sidebarToggle()">
          <span class=" navbar-toggler-bar bar1"> </span>
          <span class=" navbar-toggler-bar bar2"> </span>
          <span class=" navbar-toggler-bar bar3"> </span>
        </button>
      </div>
      <a class=" pb-2" style="color: #f9c112;text-transform: capitalize" href="javascript:void(0)"><i class="fa fa-user"></i> {{getTitle()}} </a>
      <!--      <a class=" navbar-brand" href="javascript:void(0)" *ngIf="this.apiService.currentDirection === 'rtl'" [ngStyle]="{'right': this.apiService.currentDirection === 'rtl'? '23px':  '0'}"> {{ getTitle() }} </a>-->
    </div>
    <button
      aria-label="Toggle navigation"
      class=" navbar-toggler"
      (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample"
      id="navigation"
      type="button"
    >
      <span class=" navbar-toggler-bar navbar-kebab"> </span>
      <span class=" navbar-toggler-bar navbar-kebab"> </span>
      <span class=" navbar-toggler-bar navbar-kebab"> </span>
    </button>
    <div class=" navbar-collapse" [ngbCollapse]="isCollapsed" id="navigation">
      <!--      <ul class=" navbar-nav">-->

      <ul class=" navbar-nav" [ngClass]="this.apiService.currentDirection==='rtl'?'mr-auto':'ml-auto'">
        <li class="nav-item language" style="cursor: pointer" *ngIf="this.apiService.currentDirection === 'rtl'"
            (click)="changeLanguage('en-us')"><i class="fa fa-globe"> </i>&nbsp;<span>En</span></li>
        <li class="nav-item language" style="cursor: pointer;" *ngIf="this.apiService.currentDirection === 'ltr'"
            (click)="changeLanguage('fa-ir')"><i class="fa fa-globe"> </i>&nbsp;<span
          style="font-family: vazir-regular!important">فا</span></li>
        <!--        <li class="nav-item language" style="cursor: pointer" (click)="logOut()"><i class="fa fa-sign-out m-rtl-rotate"></i>  {{'Menu.LogOut'|translate}}</li>-->


        <li class=" nav-item">
          <div class="dropdown">
            <div class=" photo">
              <img alt="Profile Photo" [src]="internalService.profilePic?internalService.profilePic:'../../../../assets/img/default-avatar.png'"/>

            </div>
            <i class="fa fa-sort-desc mx-1 k-cursor-pointer" aria-hidden="true"></i>
            <div class="dropdown-content">

              <a [routerLink]="['/profile']">{{'Users.Profile'|translate}}</a>
              <a  (click)="logOut()"> {{'Menu.LogOut'|translate}}</a>
            </div>
          </div>
        </li>

        <!---------------------mobile menu------------------------------>
        <li class=" nav-item mobileMenu">
          <a [routerLink]="['/profile']">{{'Users.Profile'|translate}}</a>
        </li>
        <li class=" nav-item mobileMenu">
          <a  (click)="logOut()"> {{'Menu.LogOut'|translate}}</a>
        </li>
        <!--------------------mobile menu end---------------------------->
        <!--        <li class="nav-item" ngbDropdown>-->
        <!--          <a-->
        <!--            class=" nav-link"-->
        <!--            data-toggle="dropdown"-->
        <!--            href="javascript:void(0)"-->
        <!--            ngbDropdownToggle-->
        <!--          >-->
        <!--            <div class=" photo">-->
        <!--              <img alt="Profile Photo" src="../../../../assets/img/default-avatar.png"/>-->
        <!--            </div>-->
        <!--            <b class=" caret d-none d-lg-block d-xl-block"> </b>-->
        <!--            &lt;!&ndash;            <p class=" d-lg-none" (click)="logOut()">Log out</p>&ndash;&gt;-->
        <!--          </a>-->
        <!--          <ul class="dropdown-navbar" ngbDropdownMenu>-->
        <!--            <li class="nav-link">-->
        <!--              <a class="nav-item" href="javascript:void(0)" ngbDropdownItem [routerLink]="['/profile']">-->
        <!--                {{'Users.Profile'|translate}}-->
        <!--              </a>-->
        <!--            </li>-->
        <!--            <li class=" dropdown-divider"></li>-->
        <!--            <li class=" nav-link">-->
        <!--              <a class=" nav-item" (click)="logOut()" href="javascript:void(0)" ngbDropdownItem>-->
        <!--                {{'Menu.LogOut'|translate}}-->
        <!--              </a>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </li>-->

      </ul>
    </div>
  </div>
</nav>

<ng-template #content let-modal>
  <div class=" modal-header">
    <input
      class=" form-control"
      id="inlineFormInputGroup"
      placeholder="SEARCH"
      type="text"
    />

    <button
      aria-label="Close"
      class=" close"
      data-dismiss="modal"
      type="button"
      (click)="modal.dismiss('Cross click')"
    >
      <i class=" tim-icons icon-simple-remove"> </i>
    </button>
  </div>

</ng-template>
